import { createBrowserRouter } from "react-router-dom"
import Layout from "../Layout/Layout"
import ErrorPage from "../Pages/ErrorPage"
import MainPage from "../Components/MainPage"
import ContactUs from "../Pages/ContactUs"
import Marketathon from "../Pages/Marketathon"
import Sponsors from "../Pages/Sponsors"
import Product from "../Pages/Product"

// Teacher Portal Components
import TeacherLogin from "../Pages/TeacherLogin"
import TeacherRegister from "../Pages/TeacherRegister"
import TeacherDashboard from "../Pages/TeacherDashboard"

// Admin Components
import SuperAdminDashboard from "../Pages/SuperAdminDashboard"

export const ROOT = "/"
export const CONTACT = "/contact"
export const MARKETATHON = "/marketathon"
export const SPONSORS = "/sponsors"
export const PRODUCT = "/product"

// Teacher Portal Routes
export const TEACHER_LOGIN = "/teacher/login"
export const TEACHER_REGISTER = "/teacher/register"
export const TEACHER_DASHBOARD = "/teacher/dashboard"

// Admin Routes
export const ADMIN_LOGIN = "/admin/login"
export const ADMIN_DASHBOARD = "/admin/dashboard"

export const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: ROOT,
        element: <MainPage />,
      },
      {
        path: CONTACT,
        element: <ContactUs />,
      },
      {
        path: MARKETATHON,
        element: <Marketathon />,
      },
      {
        path: SPONSORS,
        element: <Sponsors />,
      },
      {
        path: PRODUCT,
        element: <Product />,
      }
    ],
  },
  {
    path: TEACHER_LOGIN,
    element: <TeacherLogin />,
    errorElement: <ErrorPage />,
  },
  {
    path: TEACHER_REGISTER,
    element: <TeacherRegister />,
    errorElement: <ErrorPage />,
  },
  {
    // ForgotPassword route removed
    errorElement: <ErrorPage />,
  },
  {
    path: TEACHER_DASHBOARD,
    element: <TeacherDashboard />,
    errorElement: <ErrorPage />,
  },
  {
    path: ADMIN_LOGIN,
    element: <TeacherLogin />,
    errorElement: <ErrorPage />,
  },
  {
    path: ADMIN_DASHBOARD,
    element: <SuperAdminDashboard />,
    errorElement: <ErrorPage />,
  },
])